import { apiRequest } from './queryClient';
import { TranscriptionRequest, TranscriptionResponse } from '@/types/transcription';

export class TranscriptionClient {
  /**
   * Transcribe audio to text using the backend API
   */
  static async transcribe(request: TranscriptionRequest): Promise<TranscriptionResponse> {
    const response = await apiRequest('POST', '/transcription/transcribe', request);
    return response.json();
  }
}
